import React from 'react'
import { Image, View } from '@aws-amplify/ui-react'

export const authModalComponents = {
  Header() {
    return (
      <View textAlign="center">
        <Image alt="Greenspark logo" src="/logo-vert-light.svg" height="80%" width="80%" />
      </View>
    )
  },
}
